module.exports = __webpack_public_path__ + "static/img/games_center_btn.1d9c84ff.png";